import apiClient, { safeJson } from '@/api/client';
import { MemberTicketPayment, CreateMemberTicketPaymentBody } from './types';

export const getMemberTicketPayments = async (centerId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/member-ticket-payments`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: MemberTicketPayment[]; totalResults: number } | null };
};

export const createMemberTicketPayment = async (centerId: string, body: CreateMemberTicketPaymentBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/member-ticket-payments`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};
